import React from "react";
import useStyles from "./styles";
import NumberFormat from "react-number-format";
import clsx from "clsx";
import ImagesConfig from "components/ImagesConfig";

import { Images } from "config/images";
import { Grid, TextField } from "@material-ui/core";
import { formatCash } from "config/constant";

function NumberFormatCustom(props) {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			autoComplete="off"
			onValueChange={values => {
				onChange({
					target: {
						name: props.name,
						value: values.value
					}
				});
			}}
			isNumericString
		/>
	);
}

const ProductCartItem = props => {
	const classes = useStyles();
	const { product, productDetail, handleChangeValue, handleOnFocus } = props;

	return (
		<Grid classes={{ root: classes.borderProduct }}>
			<Grid classes={{ root: classes.img }}>
				<ImagesConfig
					image={product?.image}
					imageDefault={Images.icProductDefault}
					width={95}
					height={95}
				/>
			</Grid>
			<Grid classes={{ root: classes.body }}>
				<Grid classes={{ root: classes.bodyInfoProduct }}>
					<Grid classes={{ root: classes.nameProduct }}>
						{product.name}
					</Grid>
				</Grid>
				<Grid
					classes={{
						root: clsx(classes.bodyInfoProduct, classes.mt10)
					}}
				>
					<Grid style={{ display: "flex" }}>
						<Grid classes={{ root: classes.cartType }}>Thùng</Grid>
						<Grid
							classes={{
								root: classes.priceCart
							}}
						>
							{formatCash(
								product?.maxUnitQuantity * product?.price
							)}{" "}
							Đ
						</Grid>
					</Grid>
					<Grid>
						<TextField
							placeholder={
								productDetail?.totalBox
									? `${productDetail?.totalBox}`
									: "0"
							}
							value={
								productDetail?.totalBox
									? `${productDetail?.totalBox}`
									: null
							}
							name="THUNG"
							inputProps={{ pattern: "[0-9]*" }}
							onChange={e => {
								handleChangeValue(e);
							}}
							classes={{ root: classes.customInput }}
							onClick={event => {
								event.stopPropagation();
								handleOnFocus();
							}}
							InputProps={{
								inputComponent: NumberFormatCustom
							}}
						/>
					</Grid>
				</Grid>
				<Grid
					classes={{
						root: clsx(classes.bodyInfoProduct, classes.mt10)
					}}
				>
					<Grid style={{ display: "flex" }}>
						<Grid classes={{ root: classes.cartType }}>Lẻ</Grid>
						<Grid
							classes={{
								root: classes.priceCart
							}}
						>
							{formatCash(product?.price)} Đ
						</Grid>
					</Grid>
					<Grid>
						<TextField
							placeholder={
								productDetail?.totalDetail
									? `${productDetail?.totalDetail}`
									: "0"
							}
							value={
								productDetail?.totalDetail
									? `${productDetail?.totalDetail}`
									: null
							}
							name="LE"
							inputProps={{ pattern: "[0-9]*" }}
							onChange={e => {
								handleChangeValue(e);
							}}
							onClick={event => {
								event.stopPropagation();
								handleOnFocus();
							}}
							classes={{ root: classes.customInput }}
							InputProps={{
								inputComponent: NumberFormatCustom
							}}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ProductCartItem;
